import {mergeInnerProperties} from '../store_utils';
import {
    SET_SHOPPING_CART,
    SET_BOARDING_OPTIONS,
} from 'od-modules/secure_store/actions';

export default function shoppingCart(state = {}, action) {
    switch (action.type) {
        case SET_SHOPPING_CART:
            return mergeInnerProperties(['requiredTravellerInformation', 'requiredBuyerInformation', 'paymentResultsDTO'], state,
                {shoppingCart: action.entry}, {bookingId: action.entry && action.entry.bookingId || state.bookingId});
        case SET_BOARDING_OPTIONS:
            return Object.assign({}, state, {boardingOptionsConfig: action.entry});
        default:
            return state;
    }
}
